import { useCallback } from "react";
import ComprasService from "../api/compras.api";
import useCargaPeriodica from "./useCargaPeriodica";

/**
 * Hook que carga los pedidos de compra pendientes del ejercicio (GET /compras/:ano/estados).
 * Con intervaloMs > 0 los refresca periódicamente y en silencio (sin loading).
 * @param {number} ejercicio - Año del ejercicio
 * @param {{ intervaloMs?: number }} [opciones] - Refresco periódico opcional
 * @returns {{ pedidos: Array, loading: boolean, error: (string|null), recargar: Function }}
 */
const usePedidosCompra = (ejercicio, { intervaloMs } = {}) => {
    const cargar = useCallback(() => ComprasService.getEstados(ejercicio), [ejercicio]);
    const { datos, loading, error, recargar } = useCargaPeriodica(cargar, { intervaloMs });

    return { pedidos: datos, loading, error, recargar };
};

export default usePedidosCompra;
